/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Program } from './data';
import Navigation from './Navigation';
import TagSelector from './TagSelector';

interface DetailsProps {
  program: Program;
  onBack: () => void;
  onDone: () => void;
}

export default function Details({ program, onBack, onDone }: DetailsProps) {
  return (
    <div>
      <h2>{program.title}</h2>
      <p style={{ marginBottom: '1rem' }}>
        Almost done! Just need a few more details ...
      </p>
      <div className="details-inputgroup">
        <label htmlFor="reason">Reason for recognition</label>
        <textarea name="reason" rows={4} />
      </div>
      <div className="details-inputgroup">
        <label>Tags</label>
        <TagSelector />
      </div>
      <div className="details-inputgroup">
        <label htmlFor="points">The recognition program awards</label>
        <div className="details-inputgroup-text">
          <input name="points" type="number" />
          <span>Points</span>
        </div>
      </div>
      <Navigation
        next="Recognise"
        onNext={onDone}
        back="Back"
        onBack={onBack}
      />
    </div>
  );
}
